import { isDevMode, NgModule } from '@angular/core';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { rootReducers, RootState } from './root-state';
import { MetaReducer, StoreModule } from '@ngrx/store';
import { clearStateMetaReducer } from './root.reducer';

import { ProfileStoreModule } from '@features/profile/store';
import { AuthStoreModule } from '@features/auth/store';
import { OnDemandStoreModule } from '@features/on-demand/store';
import { AuthApiService } from '@core/services/api/auth.api.service';
import { UserProfileFacade } from '@features/profile/store/profile.facade';

export const metaReducers: MetaReducer<RootState>[] = [clearStateMetaReducer];

@NgModule({
  imports: [
    EffectsModule.forRoot([]),
    StoreModule.forRoot(rootReducers, { metaReducers, runtimeChecks: { strictStateImmutability: false } }),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: !isDevMode() }),
    ProfileStoreModule,
    AuthStoreModule,
    OnDemandStoreModule,
  ],
})
export class RootStoreModule {
  constructor(
    private userProfileFacade: UserProfileFacade,
    private authApi: AuthApiService
  ) {
    if (this.authApi.isAuthorized()) {
      this.userProfileFacade.initializeProfile();
    }
  }
}
